var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-box"},[_vm._m(0),_c('div',{staticClass:"body-content w-100"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('i',{staticClass:"fas fa-info"})])
}]

export { render, staticRenderFns }